import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { MultiSelect } from './inputs/MultiSelect';

export const PropertyTypeFilter = ({
  setFiltersAndSort,
  filtersAndSort,
  types,
  showTitle = true
}) => {
  const onChange = selected => {
    setFiltersAndSort({
      ...filtersAndSort,
      propertyTypes: selected.map(s => s.value)
    });
  };

  const options = types.map(t => ({
    value: t.propertyType,
    label: t.name
  }));

  const value = filtersAndSort.propertyTypes.map(t => ({
    value: t,
    label: types.find(type => type.propertyType === t)?.name
  }));

  return (
    <Form.Group>
      {showTitle && <Form.Label>Tipo de Propiedad</Form.Label>}

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Tipo de Propiedad"
      />
    </Form.Group>
  );
};
PropertyTypeFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  types: PropTypes.array.isRequired,
  showTitle: PropTypes.bool
};
